import * as xssFilters from 'xss-filters';
import { HowToData, WebsiteInformation } from '../../models';
import { changeSvgToPng } from "@jcharlesworthuk/your-mum-core/dist/functions/url-helpers";

export function getHowToStructuredData(data: HowToData, website: WebsiteInformation) {
  if (data.steps.length === 0) {
    return '';
  }
  return xssFilters.inHTMLData(JSON.stringify({
    "@context": "http://schema.org/",
    "@type": "HowTo",
    "image": {
      "@type": "ImageObject",
      "url": `${website.siteUrl}${changeSvgToPng(data.article.mainImage)}`
    },
    "name": data.article.title,
    "description": data.article.standfirst,
    "step": data.steps.map((step, index) => (
      {
        "@type": "HowToStep",
        "name": step.name,
        "text": step.text,
        "image": `${website.siteUrl}${step.image}`,
        "url": `${website.siteUrl}${data.article.route}#step${index + 1}`
      })),
  }));
}
